module.exports = __webpack_public_path__ + "static/media/error.e80c89af.svg";